// extracted by mini-css-extract-plugin
export default {"title":"PublishPaper_title__BPfoE","publish-details":"PublishPaper_publish-details__qhA0D","view-btn":"PublishPaper_view-btn__6tmR+","creator":"PublishPaper_creator__ldu7b"};